<div class="accordion-content rounded-sm">
  <div class="header" (click)="toggleAccordion()">
    <div class="title">{{ title }}</div>
    <div class="header-content">
      <ng-content select="[header-content]"></ng-content>
    </div>
    <div class="icon">
      <i class="pi pi-chevron-down" [@rotate]="visible ? 'rotated' : 'default'"></i>
    </div>
  </div>
  <div class="body" [@verticalSlideToggle]="visible ? 'open' : 'closed'">
    <ng-content></ng-content>
  </div>
</div>
